import type { R2BReferralBrandEntity } from "../../entity_types/r2bReferralBrand";

export const r2b_referral_8: R2BReferralBrandEntity = {
  token: "r2b_referral_8",
  type: "r2bReferralBrand",
  name: "Travel Tales",
  email: "mike.brown@example.com",
  website: "traveltales.com",
  meta: {
    source: "mock" as const,
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "data-model-migration",
  },
};
